import { forwardRef } from "react";
import ToggleButton, { ToggleButtonProps } from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Tooltip from "@mui/material/Tooltip";
import { DAY_HINT_PERIOD, Granularity, GRANULARITIES, GRANULARITY_LABEL } from "./granularity";

export type GranularityToggleProps = {
  value: Granularity;
  onChange: (g: Granularity) => void;
  /** "Dia" desabilitado (intervalo > 92 dias), com a dica em tooltip. */
  disabledDay?: boolean;
  dayHint?: string;
  options?: readonly Granularity[];
};

const BTN_SX = { px: 1.5, py: 0.25, textTransform: "none" } as const;

/** Botão desabilitado não recebe hover: o span segura o tooltip; recebe as props que o grupo clona. */
const HintedButton = forwardRef<HTMLSpanElement, ToggleButtonProps & { hint: string }>(function HintedButton({ hint, sx, ...props }, ref) {
  return (
    <Tooltip title={hint}>
      <span ref={ref} aria-label={hint} style={{ display: "inline-flex" }}>
        <ToggleButton {...props} sx={{ ...BTN_SX, ml: "-1px", borderTopLeftRadius: 0, borderBottomLeftRadius: 0, ...(sx as object) }} />
      </span>
    </Tooltip>
  );
});

/** Seletor Mês / Semana / Dia de todo gráfico temporal (mesmo visual do da tendência da Visão geral). */
export default function GranularityToggle({ value, onChange, disabledDay = false, dayHint = DAY_HINT_PERIOD, options = GRANULARITIES }: GranularityToggleProps) {
  return (
    <ToggleButtonGroup size="small" exclusive value={value} onChange={(_, v: Granularity | null) => v && onChange(v)} aria-label="Granularidade">
      {options.map((g) =>
        g === "day" && disabledDay ? (
          <HintedButton key={g} value={g} disabled hint={dayHint}>
            {GRANULARITY_LABEL[g]}
          </HintedButton>
        ) : (
          <ToggleButton key={g} value={g} sx={BTN_SX}>
            {GRANULARITY_LABEL[g]}
          </ToggleButton>
        ),
      )}
    </ToggleButtonGroup>
  );
}
